module.exports = __webpack_public_path__ + "files/6555dd0b70276a9750f1fbba3f81eefb.svg";